import classnames from 'classnames';

import cardStyles from '../LaboratoryService/LaboratorySelect/LaboratorySelect.module.scss';

import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { Text } from '@components/Text';
import { translate } from '@chaika/i18n/helper';

interface Props {
    name: string;
    cost?: string;
    disabled?: boolean;
    isSelected: boolean;
    onSelectClick(): void;
}

export function ContractorCard({ name, cost, disabled, isSelected, onSelectClick }: Props) {
    return (
        <div className={cardStyles.card}>
            <div className={classnames([cardStyles.laboratory, isSelected && cardStyles.laboratory_selected])}>
                {isSelected || disabled ? null : (
                    <div className={cardStyles.actionButton}>
                        <Button
                            dataTest={'contractorActionButton'}
                            theme={ButtonTheme.White}
                            modifiers={[ButtonModifiers.Small]}
                            onClick={onSelectClick}
                        >
                            {translate('select')}
                        </Button>
                    </div>
                )}
                <div className={cardStyles.field}>
                    <div className={cardStyles.name}>{name}</div>
                </div>
                {cost ? (
                    <div className={cardStyles.field}>
                        <Text
                            withoutMinHeight
                            isHidingText
                            title={translate('costPrice')}
                            text={cost}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}
